export const TEXTS = {
  DOC_TITLE: 'Вход – Звук Бизнес',
  PAGE_TITLE: 'Вход',
  BUTTON_REGISTER_LABEL: 'Еще нет аккаунта?',
  BUTTON_REGISTER_LINK_TEXT: 'Зарегистрироваться',
  SUBTITLE_CODE_DESC: (phone: string) => (
    <>
      <span>Введите код из SMS-сообщения.</span>
      <br />
      <span>Мы отправили его на номер </span>
      <span data-phone>{phone}</span>
    </>
  ),
};
